module.exports = __webpack_public_path__ + "img/97.dffb1f16.jpg";